import React from "react";

const Hero = () => {
  return (
    <div className="md:flex items-center bg-white p-8 lg:px-36 lg:py-24 pb-12 ">
      <div className="p-4 w-full lg:w-1/2">
        <h1 className="text-4xl font-bold mb-4 ">About —</h1>
        <div className="mt-8 md:hidden pb-8">
          <img src="jef.png" alt="Ali holding his book" className="w-96" />
        </div>
        <p className="text-xl mb-2">
          I’m Jeff.{" "}
          <a href="#projects" className="text-blue-500 underline">
            Software Engineer
          </a>
        </p>
        <p className="text-lg mb-4">
          My goal is to grow as a Software Engineer specializing in web-
          Applications, continuously amassing experience in various programming
          languages, frameworks and libraries. I’m currently proficient with
          front end development technologies. And actively learning backend
          technologies.
        </p>
        <p className="text-lg mb-4">
          I am Seeking an opportunity to become a part of a company where I can
          gain experience by building web projects with practical applications
          and working in a collaborative environment.
          <span className="hidden">Got a job? Get my resume below:</span>
          <div className="pt-2">
            Email:<span className="font-bold pt-4">hijeffocaya@gmail.com</span>
          </div>
        </p>
        <div className="w-full max-w-sm hidden">
          <input
            type="email"
            placeholder="Email*"
            className="w-full border border-gray-300 rounded px-4 py-2 mb-4"
          />
          <div className="flex items-center mb-4">
            <input type="checkbox" id="newsletter" className="mr-2" />
            <label htmlFor="newsletter" className="text-sm">
              If you'd like me to follow up via the same email.
            </label>
          </div>
          <button className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600">
            DOWNLOAD MY RESUME
          </button>
        </div>
      </div>
      <div className="mt-8 hidden md:block lg:pl-12">
        <img src="jef.png" alt="Jeff Ocaya" className="w-96" />
      </div>
    </div>
  );
};

export default Hero;
